import React from 'react';

export default class FileUpload extends React.Component {
    constructor(props) {
        super(props);
        this.validateOnBlur = this.validateOnBlur.bind(this);
        this.onChange = this.onChange.bind(this);

        this.state = {
            invalidInput: false,
            value: this.props.value,
            inputErrorMsg: ""
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentDidUpdate() {
        const { shouldShowError } = this.props;
        if (shouldShowError === false && this.state.inputErrorMsg !== "")
            this.setState({ inputErrorMsg: "" });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onChange(event) {
        event.persist();
        const input = event.target;
        const label = input.nextElementSibling;
        const { onChange, required } = this.props;
        const value = input.files && input.files[0] && input.files[0].name ? input.files[0].name : '';
        const fileSize = input.files && input.files[0] && input.files[0].size;
        const fileSizeInMb = fileSize ? (fileSize / 1024 / 1024).toFixed(2) : 0;
        if (value) {
            const file = input.files[0];  // setting event.target.value as empty in the last line is executed first, so need one temp variable holding the file.
            label.querySelector('span').innerHTML = value;
            this.setState({ invalidInput: false });
            this.setState({ value: value, fileSizeInMb: parseFloat(fileSizeInMb) }, () => {
                if (onChange) {
                    onChange(event, value, required && value.trim() !== '' && this.isValidate(), file);
                }
            });
        }
        event.target.value = "";  //fix to fire the onChange for same fileName
    }

    validateOnBlur(event) {
        const input = event.target;
        if (this.props.required) {
            event.persist();
            if (input.files.length || this.state.value) {
                this.setState({ invalidInput: false });
            }
            else {
                this.setState({ invalidInput: true });
            }
        }
    }
    isValidate() {
        const { value, fileSizeInMb } = this.state;
        const { maxFileSize, fileTypeErrorMsg, fileSizeErrorMsg } = this.props;
        if (value) {
            const accept = this.props.accept ? this.props.accept.toLowerCase() : "";
            const fileExtention = value.split('.').pop().toLowerCase();
            if (accept.split(',').indexOf("." + fileExtention) < 0) {
                this.setState({ inputErrorMsg: fileTypeErrorMsg || `Please select a valid document type: ${accept}`, invalidInput: true });
                return false;
            }
            else if (fileSizeInMb > maxFileSize) {
                this.setState({ inputErrorMsg: fileSizeErrorMsg || `Please select a document less than: ${maxFileSize}MB.`, invalidInput: true });
                return false;
            }
            else {
                this.setState({ inputErrorMsg: "" });
                return true;
            }
        }
        return false;
    }

    render() {
        const {
            placeholder,
            className,
            showAsInvalid,
            accept,
            value
        } = this.props;
        const { inputErrorMsg } = this.state;
        const thisValue = this.state.value || "";
        const containerClassName =
            (typeof value !== undefined ? value ? " input-not-empty" : "" : thisValue ? " input-not-empty" : "") + (className ? " " + className + " " : " ") +
            (this.state.invalidInput || showAsInvalid || inputErrorMsg ? " input-invalid" : "");

        return (<><div className={"file-select il-group" + containerClassName}>
            <input type="file" name="file-upload" className="file-input" id="file-upload" aria-label={placeholder}
                onChange={this.onChange} accept={accept} onBlur={this.validateOnBlur}
            />
            <label htmlFor="file-upload" className="file-selection form-control"><span>{typeof value !== undefined ? value : thisValue}</span> <div className="btn btn-primary">CHOOSE FILE</div></label>
            <div className="il-label" aria-hidden="true">{placeholder}</div>
            {inputErrorMsg && <div className="input-error-msg">{inputErrorMsg}</div>}
        </div>
        </>
        );
    }
}